import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { collection, deleteDoc, doc, getDoc, onSnapshot, updateDoc, deleteField } from 'firebase/firestore';
import { db } from '../../firebase';
import { useNavigate, useParams } from 'react-router-dom';
import DeleteIcon from '@mui/icons-material/Delete';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import ModalComponent from '../ModalComponent';
import Tooltip from '@mui/material/Tooltip';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import IconButton from '@mui/material/IconButton';

function List({ isMobile }) {
  const [data, setData] = useState([]);
  const { userId, albumId, photoId } = useParams();
  const [photoData, setPhotoData] = useState([]);
  const [open, setOpen] = useState(false);
  let navigate = useNavigate();

  useEffect(() => {
    const unsub = onSnapshot(
      collection(db, 'users', userId, 'albums', albumId, 'photos'),
      (snapShot) => {
        let list = [];
        snapShot.docs.forEach((doc) => {
          list.push({ id: doc.id, ...doc.data() });
        });
        setData(list);
      },
      (error) => {
        console.log(error);
      }
    );

    return () => {
      unsub();
    };
  }, [userId, albumId]);

  useEffect(() => {
    photoId && getSinglePhoto();
    // eslint-disable-next-line
  }, []);

  const getSinglePhoto = async () => {
    const docRef = doc(db, 'users', userId, 'photos', photoId);
    const snapshot = await getDoc(docRef);
    if (snapshot.exists()) {
      setPhotoData({ ...snapshot.data() });
    }
  };

  const handleOpen = (item) => {
    setOpen(true);
    setPhotoData(item);
  };

  const handleDelete = async (id) => {
    try {
      setOpen(false);
      await deleteDoc(doc(db, 'users', userId, 'albums', albumId, 'photos', id));
      await updateDoc(doc(db, 'users', userId, 'photos', id), {
        album: deleteField(),
      });

      setPhotoData(data.filter((item) => item.id !== id));
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <ListStyled>
      <div className="list-container">
        <div className="datatable">
          <ImageList sx={{ width: '100%', height: '100%' }} gap={isMobile ? 40 : 5} cols={isMobile ? 1 : 4}>
            {data.map((item) => (
              <ImageListItem key={item.img}>
                <img
                  src={`${item.img}?w=248&fit=crop&auto=format`}
                  srcSet={`${item.img}?w=248&fit=crop&auto=format&dpr=2 2x`}
                  alt={item.photo_title}
                  loading="lazy"
                />
                <ImageListItemBar
                  title={item.photo_title}
                  subtitle={item.description}
                  actionIcon={
                    <div>
                      <IconButton
                        sx={{ color: 'rgba(255, 255, 255, 0.54)' }}
                        aria-label={`info about ${item.photo_title}`}
                      >
                        <Tooltip title="View">
                          <RemoveRedEyeIcon onClick={() => navigate(`/${userId}/photos/${item.id}`)} />
                        </Tooltip>
                      </IconButton>

                      <IconButton
                        sx={{ color: 'rgba(255, 255, 255, 0.54)' }}
                        aria-label={`info about ${item.photo_title}`}
                      >
                        <Tooltip title="Delete">
                          <DeleteIcon onClick={() => handleOpen(item)} />
                        </Tooltip>
                      </IconButton>
                    </div>
                  }
                />
              </ImageListItem>
            ))}
          </ImageList>
          {open && <ModalComponent open={open} setOpen={setOpen} handleDelete={handleDelete} {...photoData} />}
        </div>
      </div>
    </ListStyled>
  );
}

const ListStyled = styled.div`
  display: flex;
  width: 100%;
  .list-container {
    flex: 6;

    .datatable {
      padding: 20px;
      .datatable-title {
        width: 100%;
        font-size: 24px;
        color: var(--accent-blue);
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .link {
          text-decoration: none;
          font-size: 16px;
          font-weight: 400;
          border: 1px solid #7199ff;
          padding: 5px;
          border-radius: 5px;
          cursor: pointer;
        }
      }

      .cellWithImg {
        display: flex;
        align-items: center;

        .cellImg {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          object-fit: cover;
          margin-right: 20px;
        }
      }

      .cellWithStatus {
        padding: 5px;
        border-radius: 5px;

        &.online {
          color: blueviolet;
          background-color: rgba(0, 128, 0, 0.151);
        }
        &.offline {
          color: red;
          background-color: rgba(189, 189, 3, 0.103);
        }
      }

      .cellAction {
        display: flex;
        align-items: center;
        gap: 15px;

        .viewButton {
          padding: 2px 5px;
          border-radius: 5px;
          color: darkblue;
          border: 1px dotted rgba(0, 0, 139, 0.6);
          cursor: pointer;
        }
        .updateButton {
          padding: 2px 5px;
          border-radius: 5px;
          color: blue;
          border: 1px dotted rgba(0, 0, 139, 0.6);
          cursor: pointer;
        }
        .deleteButton {
          padding: 2px 5px;
          border-radius: 5px;
          color: crimson;
          border: 1px dotted rgba(220, 20, 60, 0.6);
          cursor: pointer;
        }
      }
    }
  }
`;

export default List;
